let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1UBYF")).then(() => parcelRequire('cUx1P'));